// minela-kids-frontend/src/context/FavoritesContext.js

import React, { createContext, useState, useContext, useEffect } from 'react';
import { toast } from 'react-toastify'; // DÜZELTİLDİ
import { trackAddToWishlist, trackRemoveFromWishlist } from '../utils/analytics';

const FavoritesContext = createContext(null);

export const useFavorites = () => useContext(FavoritesContext);

export const FavoritesProvider = ({ children }) => {
  const [favorites, setFavorites] = useState(() => {
    try {
      const localData = localStorage.getItem('minela-favorites');
      const parsedData = localData ? JSON.parse(localData) : [];
      return Array.isArray(parsedData) ? parsedData : [];
    } catch (error) {
      console.error("Favori verileri okunurken veya ayrıştırılırken hata oluştu:", error);
      return []; 
    }
  });

  useEffect(() => {
    localStorage.setItem('minela-favorites', JSON.stringify(favorites));
  }, [favorites]);

  const toggleFavorite = (product) => {
    const isFavorited = favorites.some((item) => item.id === product.id);

    if (isFavorited) {
      setFavorites(favorites.filter((item) => item.id !== product.id));
      toast.info(`${product.name} favorilerden çıkarıldı.`);
      
      // GA4: Favorilerden çıkarma
      trackRemoveFromWishlist({
        id: product.id,
        name: product.name,
        price: product.price || product.final_price || 0,
        category: product.category || ''
      });
    } else {
      setFavorites([...favorites, product]);
      toast.success(`${product.name} favorilere eklendi!`);
      
      // GA4: Favorilere ekleme
      trackAddToWishlist({
        id: product.id,
        name: product.name,
        price: product.price || product.final_price || 0,
        category: product.category || ''
      });
    }
  };

  const isProductFavorited = (productId) => {
    return favorites.some((item) => item.id === productId);
  };

  const favoritesCount = favorites.length;

  const value = {
    favorites,
    toggleFavorite,
    isProductFavorited,
    favoritesCount,
  };

  return <FavoritesContext.Provider value={value}>{children}</FavoritesContext.Provider>;
};